var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pageBox"},[_c('div',{staticClass:"titleBox"},[_vm._v(" 常见问题 ")]),_c('div',{staticClass:"mainBox"},[(_vm.content)?_c('div',{staticClass:"problemBox html",domProps:{"innerHTML":_vm._s(_vm.content)}}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }